import React from 'react';
import styled from 'styled-components';
import { colors, neumorphism } from '../constant';

const EditButton = ({ projectUuid }) => {

    function handleClick(e) {
        e.preventDefault();
        const newWindow = window.open(`/project/${projectUuid}/edit?close-when-back=true`);
        
        function closeNewWindow() {
            newWindow.close();
            window.closeProjectEditWindow = null;
        }

        window.closeProjectEditWindow = closeNewWindow;
    }

    return (
        <EditButtonRoot onClick={handleClick}>
            編輯 
            <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1C7 1.26522 7.10536 1.51957 7.29289 1.70711C7.48043 1.89464 7.73478 2 8 2H10.586L4.293 8.293C4.19749 8.38525 4.12131 8.49559 4.0689 8.6176C4.01649 8.7396 3.9889 8.87082 3.98775 9.0036C3.9866 9.13638 4.0119 9.26806 4.06218 9.39095C4.11246 9.51385 4.18671 9.6255 4.28061 9.71939C4.3745 9.81329 4.48615 9.88754 4.60905 9.93782C4.73194 9.9881 4.86362 10.0134 4.9964 10.0123C5.12918 10.0111 5.2604 9.98351 5.38241 9.9311C5.50441 9.87869 5.61475 9.80251 5.707 9.707L12 3.414V6C12 6.26522 12.1054 6.51957 12.2929 6.70711C12.4804 6.89464 12.7348 7 13 7C13.2652 7 13.5196 6.89464 13.7071 6.70711C13.8946 6.51957 14 6.26522 14 6V1C14 0.734784 13.8946 0.48043 13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0H8Z" fill="currentColor"/>
                <path d="M2 2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V12C0 12.5304 0.210714 13.0391 0.585786 13.4142C0.960859 13.7893 1.46957 14 2 14H10C10.5304 14 11.0391 13.7893 11.4142 13.4142C11.7893 13.0391 12 12.5304 12 12V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9V12H2V4H5C5.26522 4 5.51957 3.89464 5.70711 3.70711C5.89464 3.51957 6 3.26522 6 3C6 2.73478 5.89464 2.48043 5.70711 2.29289C5.51957 2.10536 5.26522 2 5 2H2Z" fill="currentColor"/>
            </svg>
        </EditButtonRoot>
    )
}

const EditButtonRoot = styled.a`
    border-radius: 100em;
    padding: 8px 24px;
    color: ${ colors.text };
    
    ${ neumorphism.convex };
    transition: all .2s;

    display: inline-flex;
    justify-content: center;
    align-content: center;
    line-height: 1em;

    &:focus, &:hover {
        text-decoration: none;
        color: ${ colors.text };
    }

    >svg {
        margin-left: 8px;
    }

    &:active {
        ${ neumorphism.concave };
    }
`

export default EditButton
